import axiosClient from './axiosClient';

const trendingApi = {
    // Public: feed hoạt động mua sắm gần đây (optional auth để lấy isSaved)
    getFeed: ({ page = 1, limit = 20, platform = 'all' } = {}) => {
        return axiosClient.get('trending/feed', { params: { page, limit, platform } });
    },

    // Public: top sản phẩm hot trong 7 ngày
    getHotProducts: ({ timeWindow = '7d', limit = 10, platform = 'all' } = {}) => {
        return axiosClient.get('trending/hot', { params: { timeWindow, limit, platform } });
    },

    // Protected: lưu sản phẩm vào danh sách yêu thích
    saveProduct: (productData) => {
        return axiosClient.post('trending/save', productData);
    },

    // Protected: bỏ lưu sản phẩm
    unsaveProduct: (productId) => {
        return axiosClient.delete(`trending/save/${productId}`);
    },

    // Protected: danh sách sản phẩm đã lưu
    getSavedProducts: ({ page = 1, limit = 50 } = {}) => {
        return axiosClient.get('trending/saved', { params: { page, limit } });
    },

    // Protected: lịch sử duyệt sản phẩm của user
    getMyActivity: () => {
        return axiosClient.get('trending/my-activity');
    },
};

export default trendingApi;
